import { FC, useEffect, useState } from "react";
import styles from "./Clubs.module.scss";

import { ClubItem } from "../../components/ClubItem/ClubItem";
import { IClub, IResponseGetClubs } from "../../types/club";
import { getClubs } from "../../api/clubs";
import Loader from "../../components/Loader/Loader";
import { ErrorPage } from "../ErrorPage/ErrorPage";

export const Clubs: FC = () => {
  const [clubs, setClubs] = useState<IClub[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  async function fetchData() {
    try {
      setIsLoading(true);
      const data: IResponseGetClubs = await getClubs();
      setClubs(data.data);
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  if (isLoading)
    return (
      <div className="loader-container">
        <Loader size={100} borderWidth={7} />
      </div>
    );

  return (
    <div className={styles.clubsPage}>
      {clubs.length > 0 && (
        <>
          {clubs.map((club) => (
            <ClubItem {...club} />
          ))}
        </>
      )}
    </div>
  );
};
